import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, G, Path, Defs, ClipPath, Rect, LinearGradient, Stop } from 'react-native-svg';

export const LogoDiscover = ({
  width = 104,
  height = 18,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 104 18"
      className={className}
      fill="none"
    >
      <G clipPath="url(#clip0_5758_11223)">
        <Path
          d="M4.76228 0.48642H0V17.1713H4.76228C7.27964 17.1713 9.10124 16.5656 10.7089 15.2596C12.6206 13.6812 13.7419 11.3147 13.7419 8.85812C13.7127 3.91346 10.0424 0.48642 4.76228 0.48642ZM8.58561 13.0462C7.55434 13.9559 6.25063 14.3815 4.12505 14.3815H3.24465V3.33703H4.12505C6.2191 3.33703 7.49355 3.7018 8.58561 4.67227C9.70919 5.67426 10.3757 7.22116 10.3757 8.82885C10.3757 10.4365 9.70919 12.0442 8.58561 13.0462Z"
          fill="#231F20"
        />
        <Path
          d="M18.4779 0.48642H15.231V17.1735H18.4779V0.48642Z"
          fill="#231F20"
        />
        <Path
          d="M26.4258 6.88792C24.4849 6.16063 23.9085 5.67427 23.9085 4.79387C23.9085 3.73108 24.9397 2.943 26.3358 2.943C27.3062 2.943 28.1258 3.33704 28.9454 4.30751L30.6454 2.09187C29.2494 0.878219 27.5809 0.240997 25.7301 0.240997C22.7871 0.240997 20.5129 2.30352 20.5129 5.0348C20.5129 7.3405 21.5757 8.52263 24.6087 9.61694C25.8832 10.0718 26.5204 10.3758 26.8536 10.5581C27.4909 10.9837 27.8241 11.5894 27.8241 12.2874C27.8241 13.6519 26.7613 14.6539 25.3067 14.6539C23.7598 14.6539 22.5147 13.8658 21.7581 12.4383L19.6641 14.4715C21.1502 16.6872 22.9718 17.6576 25.4283 17.6576C28.7968 17.6576 31.1926 15.4127 31.1926 12.1658C31.2534 9.46608 30.1298 8.25243 26.4303 6.88792H26.4258Z"
          fill="#231F20"
        />
        <Path
          d="M32.2516 8.85808C32.2516 13.7735 36.1042 17.5653 41.0488 17.5653C42.4449 17.5653 43.6585 17.2928 45.1131 16.5948V12.7715C43.8094 14.0752 42.6565 14.5908 41.1997 14.5908C37.9235 14.5908 35.5863 12.2243 35.5863 8.82656C35.5863 5.61118 37.9821 3.09156 41.0466 3.09156C42.5935 3.09156 43.7779 3.63872 45.1108 4.9717V1.15288C43.6855 0.425588 42.5012 0.121613 41.1051 0.121613C36.2213 0.121613 32.2471 4.00574 32.2471 8.85808H32.2516Z"
          fill="#231F20"
        />
        <Path
          d="M70.9618 11.711L66.5013 0.48642H62.9526L70.0206 17.5968H71.7814L78.971 0.48642H75.4516L70.9618 11.711Z"
          fill="#231F20"
        />
        <Path
          d="M80.457 17.1713H89.6799V14.3499H83.7039V9.86011H89.4682V7.03877H83.7039V3.33703H89.6799V0.48642H80.457V17.1713Z"
          fill="#231F20"
        />
        <Path
          d="M102.574 5.43123C102.574 2.30591 100.419 0.515839 96.6585 0.515839H91.8354V17.2029H95.0824V10.4975H95.5079L99.9977 17.2029H104.003L98.7548 10.1642C101.211 9.6486 102.578 7.98012 102.578 5.43123H102.574ZM96.0213 8.19177H95.0801V3.12552H96.0821C98.1154 3.12552 99.2074 3.9744 99.2074 5.61361C99.2074 7.25283 98.1154 8.19177 96.0213 8.19177Z"
          fill="#231F20"
        />
        <Path
          d="M63.8718 10.3155C64.6584 5.46935 61.3675 0.903064 56.5214 0.116423C51.6752 -0.670218 47.1089 2.62067 46.3223 7.46682C45.5356 12.313 48.8265 16.8792 53.6727 17.6659C58.5188 18.4525 63.0851 15.1616 63.8718 10.3155Z"
          fill="url(#paint0_linear_5758_11223)"
        />
        <Path
          d="M63.8718 10.3155C64.6584 5.46935 61.3675 0.903064 56.5214 0.116423C51.6752 -0.670218 47.1089 2.62067 46.3223 7.46682C45.5356 12.313 48.8265 16.8792 53.6727 17.6659C58.5188 18.4525 63.0851 15.1616 63.8718 10.3155Z"
          fill="url(#paint1_linear_5758_11223)"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_5758_11223"
          x1="59.6472"
          y1="16.0012"
          x2="53.5024"
          y2="6.37983"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F89F20" />
          <Stop offset="0.25" stopColor="#F79A20" />
          <Stop offset="0.53" stopColor="#F68D20" />
          <Stop offset="0.62" stopColor="#F58720" />
          <Stop offset="0.72" stopColor="#F48120" />
          <Stop offset="1" stopColor="#F37521" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_5758_11223"
          x1="58.6767"
          y1="15.8706"
          x2="49.6971"
          y2="-1.68113"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F58720" />
          <Stop offset="0.36" stopColor="#E16F27" />
          <Stop offset="0.7" stopColor="#D4602C" />
          <Stop offset="0.98" stopColor="#D05B2E" />
        </LinearGradient>
        <ClipPath id="clip0_5758_11223">
          <Rect width="104" height="17.7792" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
